import i18n from "../../resources/I18n";
import { DsdLoading } from "../DSD/DsdLoading";
import "./modalLoadingAMC.css";

function ModalLoadingAMC() {
  return (
    <dsd-backdrop>
      <dsd-container class="loading-centered-amc full-height">
        <DsdLoading id="element-modal-loading-amc" size="xs">
          <span>{i18n.t("amc:message-chargement")}</span>
        </DsdLoading>
      </dsd-container>
    </dsd-backdrop>
  );
}

export default ModalLoadingAMC;
